import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAGTBxZqeWW-sdWCSrjQzlmB8eToMa0OMQ",
  authDomain: "heliocentricastro.com",
  projectId: "heliocentric-9a025",
  storageBucket: "heliocentric-9a025.firebasestorage.app",
  messagingSenderId: "644643938175",
  appId: "1:644643938175:web:b7c4622451a9816271c44a",
  measurementId: "G-N30M8M6540",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const appleProvider = new OAuthProvider("apple.com");

let analytics = null;
if (typeof window !== "undefined") {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  });
}

export { app, analytics, auth, googleProvider, appleProvider };
